import { SearchInput } from "../../../components/SearchInput";
import Filters from "./Filters";
import { CustomButton } from "../../../components/CustomButton";
import DateRangePicker from "../../../components/DateRangePicker";
import typography from "../typography";
import filterIcon from "../../../assets/icons/filter.svg";
import exportIcon from "../../../assets/icons/export.svg";

export default function Header({
  statusFilterVal = 1,
  filterUpdateHandler = () => {},
  planFilterVal = 1,
  searchTextVal = "",
  searchValUpdateHandler = () => {},
  showAdvancedFilters = false,
  onAdvancedFilterToggle = () => {},
  metricTypeFilterVal = 1,
  range,
  onRangeChange = () => {},
  onRangeClear = () => {},
  handleExportClick = () => {},
  isExportCSVLoading = false,
}) {
  const statusFilterConfig = [
    {
      id: 1,
      title: typography.ALL,
    },
    {
      id: 2,
      title: typography.ACTIVE,
    },
    {
      id: 3,
      title: typography.INACTIVE,
    },
  ];
  const planFilterConfig = [
    {
      id: 1,
      title: typography.ALL,
    },
    {
      id: 2,
      title: typography.FREE,
    },
    {
      id: 3,
      title: typography.PREMIUM,
    },
  ];

  const metricTypeFilterConfig = [
    {
      id: 1,
      title: typography.ALL,
    },
    {
      id: 2,
      title: typography.ENGAGED_USERS,
    },
    {
      id: 3,
      title: typography.DELETED_USERS,
    },
    {
      id: 4,
      title: typography.IDLE_USERS,
    },
    {
      id: 5,
      title: typography.SIGNUPS,
    },
  ];

  return (
    <div className="my-4">
      <div className="export-btn-con">
        <CustomButton
          // title={"Export CSV"}
          title={
            <div className="d-flex align-items-center">
              <img src={exportIcon} alt="export csv" className="me-2" />
              {typography.EXPORT_CSV}
            </div>
          }
          loading={isExportCSVLoading}
          className="btn btn-primary export-btn"
          outline
          onClick={handleExportClick}
        />
      </div>
      <div className="header-con">
        <div className="filters-parent-con">
          <Filters
            activeTab={statusFilterVal}
            tabClickHandler={filterUpdateHandler}
            config={statusFilterConfig}
            className="me-5 status-filter-con"
            label="Status"
            filterType="status"
          />
          <Filters
            activeTab={planFilterVal}
            tabClickHandler={filterUpdateHandler}
            config={planFilterConfig}
            className="plan-filter-con"
            label="Plan"
            filterType="plan"
          />
        </div>

        <div className="search-input-main-con">
          <SearchInput
            placeholder={"Search here"}
            type="text"
            onChange={(e) => searchValUpdateHandler(e)}
            value={searchTextVal}
          />
        </div>
      </div>

      <div className="advanced-filter-right-btn">
        <CustomButton
          title={
            <div className="d-flex align-items-center">
              <img src={filterIcon} alt="filter" className="me-2" />
              <p>
                {" "}
                {showAdvancedFilters ? "Hide" : "Show"}{" "}
                {typography.ADVANCED_FILTERS}
              </p>
            </div>
          }
          className="advanced-filter-btn"
          outline
          onClick={onAdvancedFilterToggle}
        />
      </div>

      {showAdvancedFilters && (
        <div className={`advanced-filters-section mt-1 rounded`}>
          <div className="d-flex flex-wrap gap-4 advanced-filters-section-con">
            <Filters
              activeTab={metricTypeFilterVal}
              tabClickHandler={filterUpdateHandler}
              config={metricTypeFilterConfig}
              className="metric-type-filter-con"
              label={typography.METRIC_TYPE}
              filterType="metricType"
            />

            <div className="date-range-filter-con">
              <label className="form-label mb-0">{typography.DATE_RANGE}</label>
              <DateRangePicker
                range={range}
                onChange={onRangeChange}
                onClear={onRangeClear}
                showClearIcon={true}
                hasUserSelectedDate={true}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
